import React from 'react'
import { useTranslation } from 'react-i18next'
import { ButtonSizeEnum, SecondaryButton } from 'src/editor/shared/ui-lib/buttons'
import { ChevronLeftIcon } from '../icons/chevron-left-icon'

interface BackButtonProps extends Omit<React.ComponentProps<typeof SecondaryButton>, 'children'> {
  children?: React.ReactNode
}

export const BackButton = ({ children, ...props }: BackButtonProps) => {
  const { t } = useTranslation()
  return (
    <SecondaryButton
      size={ButtonSizeEnum.Small}
      iconBefore={<ChevronLeftIcon />}
      {...props}
    >
      {!children ? t('components.core.back_button') : children}
    </SecondaryButton>
  )
}